import { useState } from "react";

import { useTaskStatus } from "@/hooks/queries/use-bundle-splitter";
import { useIsSessionActive } from "@/hooks/useIsSessionActive";

import { computePollInterval } from "./Processes/pollingSchedule";

/**
 * MDRS-550: polls a task a picked file is waiting on but that isn't a row
 * here (closed away, or from another tab). The task list only learns a task
 * ended when its status is polled, so without this the hold would last until
 * the server's stale-task cut-off. Once the task ends, useTaskStatus stops
 * polling and refreshes the list, which lifts the hold and unmounts this.
 * Same backoff as the rows' polling (STP-77), and it stops with the session.
 */
export const TaskStatusWatcher = ({ taskId }: { taskId: string }) => {
  const [watchingSince] = useState(() => Date.now());
  const isSessionActive = useIsSessionActive();
  useTaskStatus({
    task_id: taskId,
    enabled: isSessionActive,
    refetchInterval: isSessionActive
      ? () => computePollInterval(Date.now() - watchingSince)
      : false,
  });
  return null;
};
